import { createStandardAction } from 'typesafe-actions'

export const GOOGLE_API_INITIALIZED = 'GOOGLE_API_INITIALIZED'

export const googleApiInitialized = createStandardAction(GOOGLE_API_INITIALIZED)()
